import React from "react";

export default function MobileUnstakeCom({
  data,
  onClaimUnstaked,
  isClaimingUnstaked,
  token
}) {
  const formatNumber = (value, decimals = 4) => {
    if (value === undefined || value === null || value === "" || isNaN(value))
      return "0";
    return Number(value).toLocaleString(undefined, { maximumFractionDigits: decimals });
  };

  if (!data || data.length === 0) {
    return (
      <div className="text-center py-4 tablenodata">
        No unstake requests found
      </div>
    );
  }

  return (
    <div className="mobileview myunstakedata">
      <div className="parentbox">
        {data.map((item, index) => {
          const {
            date = "Sep 01, 2025",
            unstakedTime = "07:02 PM",
            availableIn = "00D:00H:00M",
            availableClass = "greentexttt",
            amount = "25000",
            canWithdraw = true,
          } = item;

          const handleWithdraw = async () => {
            if (!canWithdraw || !onClaimUnstaked) return;
            try {
              await onClaimUnstaked(item.index);
            } catch (err) {
              console.error("Error claiming unstaked:", err);
            }
          };

          const buttonLabel = isClaimingUnstaked
            ? "Claiming..."
            : availableIn === "Available now" && !canWithdraw
              ? "Claimed"
              : canWithdraw
                ? "Withdraw"
                : "Locked";

          const buttonClass = canWithdraw
            ? "bluebutton"
            : availableIn === "Available now"
              ? "graybutton"
              : "bluebuttonlight";

          return (
            <div className="innerbox" key={index}>
              <div className="parentmain">
                <div className="left">
                  <p>Date</p>
                  <h6>
                    {date} <span>{unstakedTime}</span>
                  </h6>
                </div>
                <div className="left">
                  <p>Available In</p>
                  <h6 className={availableClass}>
                    {availableIn === "Available now" && !canWithdraw
                      ? "Not Available"
                      : availableIn}
                  </h6>
                </div>
              </div>

              <div className="parentmain">
                <div className="left">
                  <p>Amount</p>
                  <h6>{formatNumber(amount) + " " + token}</h6>
                </div>
              </div>

              <button
                className={buttonClass}
                onClick={handleWithdraw}
                disabled={!canWithdraw || isClaimingUnstaked}
              >
                {buttonLabel}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
